(function () {
  function initReadMore(wrapper) {
    if (wrapper.dataset.readMoreInit) return;

    var btn = wrapper.querySelector('.image-with-text__read-more');
    var text = wrapper.querySelector('.image-with-text__text--clamp');
    if (!btn || !text) return;

    wrapper.dataset.readMoreInit = 'true';

    var readMoreLabel = wrapper.dataset.readMoreLabel || 'Read More +';
    var readLessLabel = wrapper.dataset.readLessLabel || 'Read Less -';

    function updateButtonLabel(expanded) {
      btn.textContent = expanded ? readLessLabel : readMoreLabel;
    }

    function checkOverflow() {
      if (wrapper.classList.contains('is-expanded')) {
        btn.hidden = false;
        return;
      }

      var isOverflowing = text.scrollHeight > text.clientHeight + 1;
      btn.hidden = !isOverflowing;
    }

    btn.addEventListener('click', function () {
      var expanded = wrapper.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded);
      updateButtonLabel(expanded);
      btn.hidden = false;
    });

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
  }

  function init() {
    document.querySelectorAll('[data-read-more="image-with-text"]').forEach(initReadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
